module.exports = __webpack_public_path__ + "img/48ne.6f0f8f6d.svg";